export const TagName = {
	ACTION_GOAL:                   'goal',
	ACTION_SAVE:                   'save',
	ACTION_PENALTY_GOAL:           'penalty_goal',
	ACTION_PENALTY_MISS:           'penalty_miss',
	ACTION_INTERCEPTION:           'interception',
	ACTION_BULLY:                  'bully',
	ACTION_FOUL:                   'foul',
	ACTION_MISS:                   'miss',
	ACTION_TECHNICAL_FAULT:        'technical_fault',
	ACTION_CORNER:                 'corner',
	ACTION_THROW_IN:               'throw_in',
	ACTION_FREE_KICK:              'free_kick',
	ACTION_SHOT:                   'shot',
	ACTION_SHOT_TARGET:            'shot_target',
	ACTION_SHOT_POST:              'shot_post',
	ACTION_DIVE:                   'dive',
	ACTION_OFFSIDE:                'offside',
	ACTION_SCORING_CHANCE:         'scoring_chance',
	ACTION_CARD_YELLOW:            'card_yellow',
	ACTION_CARD_RED:               'card_red',
	ACTION_SERVICE_FLOAT:          'service_float',
	ACTION_SERVICE_SMASH:          'service_smash',
	ACTION_POINT:                  'point',
	ACTION_FAULT:                  'fault',
	ACTION_RALLY:                  'rally',
	ACTION_RECEPTION:              'reception',
	ACTION_PASS:                   'pass',
	ACTION_ATTACK:                 'attack',
	ACTION_BLOCK:                  'block',
	ACTION_DIG:                    'dig',
	ACTION_ASSIST:                 'assist',
	ACTION_OWN_GOAL:               'own_goal',
	ACTION_FLOOR_GAME:             'floor_game',
	ACTION_HANDS:                  'hands',
	ACTION_PERSONAL_PENALTY:       'personal_penalty',
	ACTION_FREE_HIT:               'free_hit',
	ACTION_TACKLE:                 'tackle',
	ACTION_WON_TACKLE:             'won_tackle',
	ACTION_GOAL_KICK:              'goal_kick',
	ACTION_COMPLETED_PASS:         'completed_pass',
	ACTION_7M_MISS:                '7m_miss',
	ACTION_7M_SAVE:                '7m_save',
	ACTION_7M_GOAL:                '7m_goal',
	ACTION_WARNING:                'warning',
	ACTION_2_MINUTES:              '2_minutes',
	ACTION_5_MINUTES:              '5_minutes',
	ACTION_10_MINUTES:             '10_minutes',
	ACTION_DQ_WO_REVIEW:           'disqualification_without_review',
	ACTION_DQ_W_REVIEW:            'disqualification_with_review',
	ACTION_2PLUS2_MINUTES:         '2plus2_minutes',
	ACTION_MTO_ATTACK:             'mto_attack',
	ACTION_2PLUS10_MINUTES:        '2plus10_minutes',
	ACTION_GAME_MISCONDUCT:        'game_misconduct',
	ACTION_ICING:                  'icing',
	ACTION_FIGHT:                  'fight',
	ACTION_BLOCKED_SHOT:           'blocked_shot',
	ACTION_TIMEOUT:                'timeout',
	ACTION_EMPTY_GOAL:             'empty_goal',
	ACTION_GOALIE_IN_GOAL:         'goalie_in_goal',
	ACTION_CRASH:                  'crash',
	ACTION_JUMP:                   'jump',
	PHASE_OFFENSE:                 'offense',
	PHASE_DEFENSE:                 'defense',
	TIMING_HALFTIME_START:         'halftime_start',
	TIMING_HALFTIME_END:           'halftime_end',
	TIMING_PENALTY_SHOOTOUT_START: 'penalty_shootout_start',
	TIMING_PENALTY_SHOOTOUT_END:   'penalty_shootout_end',
	TIMING_SET_START:              'set_start',
	TIMING_SET_END:                'set_end',
	TIMING_THIRD_START:            'third_start',
	TIMING_THIRD_END:              'third_end',
	TIMING_RACE_START:             'race_start',
	TIMING_RACE_END:               'race_end',
	TIMING_1ST_RUN_START:          '1st_run_start',
	TIMING_2ND_RUN_START:          '2nd_run_start',
	TIMING_OVERTIME_START:         'overtime_start',
	TIMING_OVERTIME_END:           'overtime_end',
	TIMING_QUARTER_START:          'quarter_start',
	TIMING_QUARTER_END:            'quarter_end',
	TIMING_MATCH_START:            'match_start',
	TIMING_MATCH_END:              'match_end',
	TIMING_GAME_START:             'game_start',
	TIMING_GAME_END:               'game_end',
	TIMING_EVENT_START:            'event_start',
	TIMING_EVENT_END:              'event_end',
	TIMING_TEAM_TMO:               'team_time_out',
	TIMING_MEDICAL_TMO:            'medical_time_out',
	TIMING_CLOCK_START:            'clock_start',
	TIMING_CLOCK_END:              'clock_end',
	TIMING_CLOCK_SET:              'clock_set',
	CUT:                           'cut',
	RUN:                           'run',
	SUBSTITUTION:                  'substitution',
	SCORE_SET:                     'score_set',
	WHISTLE:                       'whistle',
	SCENE:                         'scene',
	ACTION_NULL:                   'nuller',
	ACTION_NUMBER:                 'nummer',
	ACTION_FIELD_HIT:              'abtun',
	ACTION_SET:                    'setzen',
	ACTION_NOUSS_HIT:              'abschlag',
	TIMING_UMGANG_START:           'umgang_start',
	TIMING_UMGANG_END:             'umgang_end',
	ACTION_FG:                     'fg',
	ACTION_THREE_PT:               '3pt',
	ACTION_AIR_BALL:               'air_ball',
	ACTION_FT:                     'ft',
	ACTION_FT_MISS:                'ft_miss',
	ACTION_STEAL:                  'steal',
	ACTION_TURNOVER:               'turnover',
	ACTION_CHARGE:                 'charge',
	ACTION_PASS_BACK:              'pass_back',
	ACTION_DUNK:                   'dunk',
	ACTION_DRIBBLING:              'dribbling',
	ACTION_FREE_THROW:             'free_throw',
	ACTION_REBOUND:                'rebound',
	ACTION_ALLEY_OOP:              'alley_oop',
	ACTION_BASE_SINGLE:            'base_single',
	ACTION_BASE_DOUBLE:            'base_double',
	ACTION_BASE_TRIPLE:            'base_triple',
	ACTION_HOME_RUN:               'home_run',
	ACTION_BUNT:                   'bunt',
	ACTION_SCORE:                  'score',
	ACTION_DOUBLE_PLAY:            'double_play',
	ACTION_TRIPLE_PLAY:            'triple_play',
	ACTION_SAC_FLY:                'sac_fly',
	ACTION_STRIKE_OUT:             'strike_out',
	ACTION_FIELDERS_CHOICE:        'fielders_choice',
	ACTION_P_OUT:                  'p_out',
	ACTION_BASE_ON_BALLS:          'base_on_balls',
	TIMING_PLAY_BALL:              'play_ball',
	TIMING_INNING_START:           'inning_start',
	TIMING_INNING_MID:             'inning_mid',
	TIMING_INNING_END:             'inning_end',
	TIMING_GAME_BALL:              'game_ball',
	ACTION_VIOLATION:              'violation',
	ACTION_HELD_BALL:              'held_ball',
	ACTION_FALLEN_PLAYER:          'fallen_player',
	ACTION_TRY:                    'try',
	ACTION_GATE_TOUCH:             'gate_touch',
	ACTION_GATE_MISS:              'gate_miss',
	ACTION_GATE_WRONG:             'gate_wrong',
	ACTION_DIFFICULT_ELEMENT:      'difficult_element',
};
